<script lang="ts" setup>
import type { NewCategoryMenuItem } from '~/types/menus'

defineProps<{
  data: NewCategoryMenuItem
  isActive: boolean
}>()
</script>

<template>
  <div
    class="
      mb-2 flex cursor-pointer items-center justify-between rounded-[12px] bg-white p-[16px_12px] text-sm
      leading-snug tracking-[-0.01em] text-main-dark !no-underline hover:bg-main-gray-low
      md:mb-3 md:text-base
    "
    :class="{ 'md:!bg-main-gray-low': isActive }"
  >
    <div class="flex items-center">
      <img :alt="data.name" class="!size-6" loading="lazy" :src="data.iconPath">

      <span class="mx-2">
        {{ data.name }}
      </span>
    </div>

    <SvgIcon class="!size-6 md:!hidden [&_path]:!stroke-main-green" name="outlined/arrow-next" />
  </div>
</template>
